import React, { useRef, useState } from "react";
import { Box, Typography } from "@mui/material";
import {
  CloudUpload as Upload,
  Description as FileSpreadsheet,
} from "@mui/icons-material";

export function UploadZone({
  onFileSelect,
  acceptedFormats = [".csv", ".xls", ".xlsx"],
}) {
  const [isDragging, setIsDragging] = useState(false);
  const fileInputRef = useRef(null);

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);

    const file = e.dataTransfer.files[0];
    if (file && isValidFileType(file)) {
      onFileSelect(file);
    }
  };

  const handleFileInput = (e) => {
    const file = e.target.files?.[0];
    if (file && isValidFileType(file)) {
      onFileSelect(file);
    }
  };

  const isValidFileType = (file) => {
    const extension = "." + file.name.split(".").pop()?.toLowerCase();
    return acceptedFormats.includes(extension);
  };

  const handleClick = () => {
    fileInputRef.current?.click();
  };

  return (
    <Box
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      onClick={handleClick}
      sx={{
        border: "2px dashed",
        borderColor: isDragging ? "#3B82F6" : "#D1D5DB",
        backgroundColor: isDragging ? "#EFF6FF" : "#F9FAFB",
        borderRadius: "8px",
        padding: "48px",
        textAlign: "center",
        cursor: "pointer",
        transition: "all 0.3s ease",
        "&:hover": {
          borderColor: isDragging ? "#3B82F6" : "#9CA3AF",
          backgroundColor: isDragging ? "#EFF6FF" : "#F3F4F6",
        },
      }}
    >
      <input
        ref={fileInputRef}
        type="file"
        accept={acceptedFormats.join(",")}
        onChange={handleFileInput}
        style={{ display: "none" }}
      />

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
        }}
      >
        <Box
          sx={{
            width: 64,
            height: 64,
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: isDragging ? "#DBEAFE" : "#E5E7EB",
            margin: "0 auto",
          }}
        >
          {isDragging ? (
            <Upload style={{ width: 32, height: 32, color: "#3B82F6" }} />
          ) : (
            <FileSpreadsheet
              style={{ width: 32, height: 32, color: "#6B7280" }}
            />
          )}
        </Box>

        <Box>
          <Typography
            sx={{
              color: "#111827",
              mb: 0.5,
              fontSize: "16px",
            }}
          >
            Drop your file here, or{" "}
            <Typography
              component="span"
              sx={{
                color: "#3B82F6",
                fontWeight: 500,
              }}
            >
              browse
            </Typography>
          </Typography>
          <Typography
            sx={{
              color: "#6B7280",
              fontSize: "14px",
            }}
          >
            Supports: {acceptedFormats.join(", ")}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}
